// Marque AMR (décision AMR) : le logo AMR est le seul logo, sur pastille blanche (lisible en thème sombre) ;
// « WANGRE » est le nom de la plateforme, en texte secondaire.
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';

export function BrandMark({ size = 48, className }: { size?: number; className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={cn('flex shrink-0 rounded-full bg-[#FFFFFF] p-0.5', className)} style={{ width: size, height: size }}>
      <img src="/brand/logo-amr.webp" alt={t('app.logo_alt')} width={size} height={size} className="size-full rounded-full" />
    </span>
  );
}

/** Bloc de la Sidebar : logo 48 px + « WANGRE » + « Plateforme de gestion » (maquette hf-lib). */
export function BrandBlock({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2.5 px-2 pt-1 pb-3.5">
      <BrandMark size={compact ? 40 : 48} />
      {!compact && (
        <div className="flex flex-col">
          <span className="text-body font-bold">{t('app.platform')}</span>
          <span className="text-small text-text-2">{t('app.platform_tagline')}</span>
        </div>
      )}
    </div>
  );
}
